module.exports = __webpack_public_path__ + "static/media/github-default.bffbe025.svg";